/// <reference path="../../_ext/editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationIssueItemsDialog extends _Ext.ItemEditorDialog<CertificationIssueItemsRow> {
        protected getFormKey() { return CertificationIssueItemsForm.formKey; }
        //protected getIdProperty() { return CertificationIssueItemsRow.idProperty; }
        protected getLocalTextPrefix() { return CertificationIssueItemsRow.localTextPrefix; }
        // protected getNameProperty() { return CertificationIssueItemsRow.nameProperty; }
        //protected getService() { return CertificationIssueItemsService.baseUrl; }
        protected getDeletePermission() { return CertificationIssueItemsRow.deletePermission; }
        protected getInsertPermission() { return CertificationIssueItemsRow.insertPermission; }
        protected getUpdatePermission() { return CertificationIssueItemsRow.updatePermission; }

        protected form = new CertificationIssueItemsForm(this.idPrefix);

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            //q.hideEditorLabel(this.form.LaborDetails);


            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            //this.form.LaborDetails.LaborListId = this.LaborListId;
            //this.form.LaborDetails.LaborMarkup = this.LaborMarkup;


            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                if (this.form.ItemTypeId.value != 101) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (this.form.CalcOnId.value == "3") {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });
            // **** On Weight Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (this.form.ItemTypeId.value != 101) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5") {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            this.form.UnitRate.changeSelect2(e => {
                if (this.form.CalcOnId.value == "3") {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5") {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
            });
            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.ItemTypeId.value != 101) {
                    var weight = parseFloat(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5") {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    } else {
                        var pieces = parseInt(this.form.Pieces.value.toString());                        
                        if (this.form.CalcOnId.value == "3") {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        }
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

       
            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                        var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                        for (var k of this.form.BOMDetails.getItems()) {

                            if (k.ItemTypeId == 104) {
                                Wt += k.Weight;
                            }
                            if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                                cts += k.Weight;
                                diapcs += k.Pieces
                            }
                            if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                                gms += k.Weight;
                                clrpcs += k.Pieces;
                            }

                            rate += k.BomAmount;

                        }
                        this.form.NetWeight.value = Wt;
                        this.form.OtherPieces.value = othrpcs;
                        this.form.StonePieces.value = clrpcs;
                        this.form.StoneWeight.value = gms;
                        this.form.DiamondPieces.value = diapcs;
                        this.form.DiamondWeight.value = cts;
                        this.form.Weight.value = Wt + gms + (cts / 5);
                        this.form.UnitRate.value = rate;
                        this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                        if (this.form.Pieces.value != null) {
                            var pieces = parseInt(this.form.Pieces.value.toString());
                            var netamount = parseFloat(this.form.NetAmount.value.toString());
                            this.form.GrossAmount.value = (pieces * netamount);
                        }
                        if (!this.HasBom && this.entity.ItemTypeId == 101) {
                            this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                            this.form.NetWeight.value = this.entity.NetWeight;
                            this.form.UnitRate.value = this.entity.UnitRate;
                            this.form.NetAmount.value = this.entity.UnitRate * this.entity.Weight;
                            this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;
                        }
                    }); 


            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

           
            // **** Set Stone Type in SubType ****
            this.form.ProductTypeId.changeSelect2(e => {
                this.Setfields();
                this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                if (this.form.ProductTypeId.value == "11") {
                    this.form.SubCategoryId.cascadeField = "CategoryId";
                    this.form.SubCategoryId.cascadeValue = "124";
                }
                if (this.form.ProductTypeId.value == "12") {
                    this.form.SubCategoryId.cascadeField = "CategoryId";
                    this.form.SubCategoryId.cascadeValue = "125";
                }


            });

            // **** Set Solitaire Fields ****
            this.form.SubCategoryId.changeSelect2(e => {
                var SubCatDetails = OMS.SubCategoryMasterRow.getLookup().itemById[parseInt(this.form.SubCategoryId.value)];
                //this.form.CalcOnId.value = SubCatDetails.CalcOnId;
                this.form.CategoryId.value = SubCatDetails.CategoryId.toString();
                this.form.CalcUnitId.value = SubCatDetails.CalcUnitId.toString();

                this.Setfields();
            });
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });
        }


        protected onDialogOpen() {
            super.onDialogOpen();
            this.Setfields();
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                    q.hideEditorCategory(this.form.BOMDetails);
                    q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }
        }
       
        // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() {

            //this.form.ProductId.value == undefined ? this.entity.HasBom = false : this.form.HasBom.value = true;
            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.HasBom);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    q.showAndDisableField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);

                    //q.showAndSetRequiredField(this.form.Purity);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);


                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "123";

                    switch (this.form.ProductTypeId.value) {
                        case "5":
                            this.form.SubCategoryId.value = "301";
                            break;
                        case "6":
                            this.form.SubCategoryId.value = "302";
                            break;
                        case "7":
                            this.form.SubCategoryId.value = "303";
                            break;
                    }
                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndDisableField(this.form.QualityId);
                    q.showAndDisableField(this.form.SieveId);
                    q.showAndDisableField(this.form.StoneColorId);
                    q.showAndDisableField(this.form.StoneSizeId);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);

                    q.showAndEnableField(this.form.Pieces);
                    q.showAndEnableField(this.form.Weight);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "124";

                    //this.form.SieveId.value = 131;

                    if (this.form.SubCategoryId.value == "348") {
                        q.hideField(this.form.StoneCutId);
                        q.hideField(this.form.StonePolishId);
                        q.hideField(this.form.StoneSymmetryId);
                        q.hideField(this.form.StoneFluorescenceId);
                        q.hideField(this.form.StoneCuletId);
                        q.hideField(this.form.StoneGirdleId);
                        q.hideField(this.form.StoneTable);
                        q.hideField(this.form.StoneDepth);
                        q.hideField(this.form.CertificateNo);
                    }
                    // **** Solitaire **** //
                    if (this.form.SubCategoryId.value == "349") {
                        q.showAndDisableField(this.form.Pieces);
                        q.showAndDisableField(this.form.Weight);
                        q.showAndDisableField(this.form.StoneCutId);
                        q.showAndDisableField(this.form.StonePolishId);
                        q.showAndDisableField(this.form.StoneSymmetryId);
                        q.showAndDisableField(this.form.StoneFluorescenceId);
                        q.showAndDisableField(this.form.StoneCuletId);
                        q.showAndDisableField(this.form.StoneGirdleId);
                        q.showAndDisableField(this.form.StoneTable);
                        q.showAndDisableField(this.form.StoneDepth);
                        q.showAndDisableField(this.form.CertificateNo);
                        q.showAndDisableField(this.form.Pieces);
                        q.showAndDisableField(this.form.Weight);
                        q.showAndDisableField(this.form.Lab);
                    }

                    //this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                }
            }
            else {
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.BrandId) : q.showAndSetRequiredField(this.form.BrandId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CollectionId) : q.showAndSetRequiredField(this.form.CollectionId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SuperTypeId) : q.showAndSetRequiredField(this.form.SuperTypeId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductSizeId) : q.showAndSetRequiredField(this.form.ProductSizeId);
                this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                this.form.HasBom.value == true ? q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.form.SKU.value == "0" ? q.showAndEnableField(this.form.Pieces) : q.showAndDisableField(this.form.Pieces);
                this.form.SKU.value == "0" ? this.form.HasBom.value == false ? q.showAndEnableField(this.form.Weight) : q.showAndDisableField(this.form.Weight) : q.showAndDisableField(this.form.Weight)
                this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName, false);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                q.showAndDisableField(this.form.Line_No);

                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneCutId);
                q.hideField(this.form.StonePolishId);
                q.hideField(this.form.StoneSymmetryId);
                q.hideField(this.form.StoneFluorescenceId);
                q.hideField(this.form.StoneCuletId);
                q.hideField(this.form.StoneGirdleId);
                q.hideField(this.form.StoneTable);
                q.hideField(this.form.StoneDepth);
            }

            q.showAndDisableField(this.form.ProductCode);
            q.showAndDisableField(this.form.ProductName);
            q.showAndDisableField(this.form.ProductTypeId);
            q.showAndDisableField(this.form.HSN);
            //q.showAndDisableField(this.form.UnitRate);
        }
 
    }
}